import err404 from './404';
import err500 from './500';
export default {
  ...err404,
  ...err500,
  'expection.oops': 'آه...',
  'expection.homeBtn': 'الرئيسية',
};
